import { render, staticRenderFns } from "./SensorSelector.vue?vue&type=template&id=12b54e6b&"
import script from "./SensorSelector.vue?vue&type=script&lang=js&"
export * from "./SensorSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports